import React, { PureComponent } from 'react';
// import ReactTooltip from 'react-tooltip'
import { useEffect, useState, useRef, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Circle, CircleMarker, Popup, ZoomControl, Tooltip, useMap, useMapEvent, useMapEvents, LayerGroup, Polyline, GeoJSON } from 'react-leaflet'
import daimyoList from '../data/daimyolist.json';
import sekigaharaList from '../data/sekigahara_full.json';
import injectSheet from 'react-jss';
import { Scrollama, Step } from 'react-scrollama';
import '../App.css';
import BeforeProvinces from '../geojson/province_suo_nagato_simplified.json'
import AfterProvinces from '../geojson/province_chugoku.json'

const styles = {
  description: {
    margin: '10px auto 30px',
    fontSize: 22,
    lineHeight: '28px',
    '& a': {
      color: 'black',
    },
  },
  graphicContainer: {
    padding: '20vh 0vw 20vh',
    display: 'flex',
    justifyContent: 'space-between',
  },
  graphic: {
    flexBasis: '60%',
    position: 'sticky',
    width: '100%',
    height: '60vh',
    top: '20vh',
    // backgroundColor: '#aaa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      fontSize: '5rem',
      fontWeight: 700,
      textAlign: 'center',
      color: '#fff',
    },
  },
  scroller: {
    flexBasis: '38%',
    paddingRight: '2rem'
  },
  // step: {
  //   margin: '0 2rem 3rem 2rem',
  //   padding: '180px 0',
  //   backgroundColor: '#fff',
  //   boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  //   '& p': {
  //     textAlign: 'center',
  //     padding: '1rem',
  //     fontSize: '1.5rem',
  //     margin: 0,
  //   },
  //   '&:last-child': {
  //     marginBottom: 0,
  //   },
  // }
};


class Map extends PureComponent {
  state = {
    data: 0,
    map: null,
    targetCircle: null,
    zoomLevel: 6,
    initialCenterPos: [38, 136],
    userPosition: [],
    steps: [
      {
        value: 10,
        title: "関ヶ原の前後比較",
        description: "さて、江戸時代の大名配置をより深く理解するためには、関ヶ原の戦いは避けて通れません。というのも、今までお見せしてきた幕府の大名配置の原型は、関ヶ原の戦いの論功行賞で形づくられたからです。信賞必罰の名の下に、史上類を見ない規模での所領の没収や加増転封が相次ぎました。",
        centerPos: [38, 136],
        zoomLevel: 6
      },
      {
        value: 11,
        title: "関ヶ原の戦い前の勢力図",
        description: "まずは戦前の勢力図をみてください。緑色が東軍（徳川方）で、紫色が西軍、グレーはどちらにも付かなかった大名です。"
      },
      {
        value: 12,
        title: "関ヶ原の戦い後の勢力図",
        description: "そして、こちらが戦後の勢力図です。緑色の円が増え、紫色の円がほとんど無くなっていますね。"
      },
      {
        value: 15,
        description: "例えば、豊臣家で五大老の一角を占め、関ヶ原で奮戦した宇喜多秀家の57万石は、すべて召し上げられてしまいました。",
        highlightID: 8,
        zoomLevel: 8,
      },
      {
        value: 20,
        description: "西軍の総大将・毛利家は、領地没収こそ免れたものの、中国地方8か国・120万石の覇者から、周防・長門37万石の一大名へと転落しました。",
        highlightID: 3,
        zoomLevel: 7,
        areaColoring: ["周防", "長門"]
      },
      {
        value: 30,
        description: "レアなケースは薩摩藩・島津家です。地の利を活かした巧みな交渉の結果、西軍に属した大名で唯一、所領を安堵されています。",
        highlightID: 6,
        zoomLevel: 7
      },
      {
        value: 35,
        description: "一方で、東軍に与した大名の論功行賞にも、いくつかのパターンがあります。",
        zoomLevel: 7
      },
      {
        value: 36,
        description: "まず、家康の子たちは大出世を遂げます。結城秀康は家康の次男で、養子として結城家を継いだ人物です。。",
        highlightID: 39,
        zoomLevel: 7
      },
      {
        value: 37,
        description: "家康の四男で、関ヶ原で先陣を務めた松平忠吉も、武蔵忍10万石から尾張清洲52万石に加増されています。清洲城は織田信長がかつて居城とし、関ヶ原の戦い直前には東軍がここに陣営を置いたという、歴史的にも戦略的にも重要な拠点でした。",
        highlightID: 40,
        zoomLevel: 7
      },
      {
        description: "こうした藩が、のちに「親藩」として将軍家を支えていくことになるのです。",
      },
      {
        value: 50,
        description: "そんな親藩・御三家の一つである水戸藩が置かれた場所は、元々は佐竹義宣が54万石の所領を得ていました。江戸の背後を脅かす一大勢力でありながら、関ヶ原では東軍と西軍のどちらにも付かずに模様眺めをしていたため、出羽秋田へと転封、石高は半分以下に減らされてしまいました。",
        highlightID: 9
      },
      {
        description: "関ヶ原で獅子奮迅の戦いを見せた東軍の大名に対しても、論功行賞には家康の深謀遠慮が見え隠れします。"
      },
      {
        value: 55,
        description: "福島正則は、関ヶ原の戦いまで清洲城を居城としていました。清洲は江戸と上方の中継点であり、重要拠点です。豊臣恩顧の大名ということもあり、大幅な加増を受けつつも、江戸から遠く離れた安芸広島に転封されました。",
        highlightID: 19,
      },
      {
        value: 60,
        description: "伊達政宗は、家康から「百万石のお墨付き」を与えられ、50万石の加増を約束されていましたが、反故にされてしまいました。",
        highlightID: 7,
        zoomLevel: 7
      },
      {
        description: "このように、外様大名の喜びも束の間、幕藩体制の下では幕府から警戒の目を向けられることになります。"
      },
      {
        value: 70,
        description: "ここで、もう一度、江戸城からの距離のチャートを見てみましょう。",
      },
      {
        description: "第3編（制作中）に続く",
      }
    ],
    progress: 0,
  };

  // mapRef = React.createRef();

  constructor(props) {
    super(props);
    this.beforeCircleRefs = []
    this.afterCircleRefs = []
    this.sampleCircle = React.createRef();
    this.sampleTooltip = React.createRef();
    this.highlightedDaimyo = React.createRef();
    this.eventHandlers = this.eventHandlers.bind(this)
    this.beforeProvinceData = React.createRef();
    this.afterProvinceData = React.createRef();
  }

  eventHandlers() {
    console.log("hello")
  }

  flyTo(pos, zoom) {
    // this.setState({ position: pos, zoomLevel: zoom });
    const { map } = this.state;
    this.setState({ zoomLevel: zoom });
    if (map) map.flyTo(pos, zoom);
  }

  addHighlight(id, zoom) {
    this.beforeCircleRefs.filter(el => el.options.num !== id).forEach(el => {
      el.setStyle({
        fillOpacity: 0.15
      });
    })
    this.beforeCircleRefs[id - 1].setStyle({ fill: 1, fillOpacity: 0.8, fillColor: this.beforeCircleRefs[id - 1].options.team == '東' ? "yellowgreen" : "plum" })
    this.afterCircleRefs[id - 1].setStyle({ fill: 1, fillOpacity: 0.8, fillColor: this.afterCircleRefs[id - 1].options.team == '東' ? "yellowgreen" : "plum" })
    let before_lat = this.beforeCircleRefs[id-1].getLatLng().lat
    let before_lng = this.beforeCircleRefs[id-1].getLatLng().lng
    let after_lat = this.beforeCircleRefs[id-1].options.after_latlng[0] || before_lat;
    let after_lng = this.beforeCircleRefs[id-1].options.after_latlng[1] || before_lng;
    let same_position = this.afterCircleRefs.find(el => el.getLatLng().lat == before_lat && el.getLatLng().lng == before_lng)
    if (same_position) same_position.setStyle({ fill: 0 })
    this.flyTo([(before_lat + after_lat)/2, (before_lng + after_lng)/2], zoom)
  }

  removeHighlight(id) {
    this.beforeCircleRefs[id - 1].setStyle({ fillOpacity: 0.4, fillColor: this.beforeCircleRefs[id - 1].options.team == '東' ? "yellowgreen" : "plum" })
    this.afterCircleRefs[id - 1].setStyle({ fill: 0, fillColor: this.afterCircleRefs[id - 1].options.team == '東' ? "yellowgreen" : "plum" })
    let before_lat = this.beforeCircleRefs[id - 1].getLatLng().lat
    let before_lng = this.beforeCircleRefs[id - 1].getLatLng().lng
    let same_position = this.afterCircleRefs.find(el => el.getLatLng().lat == before_lat && el.getLatLng().lng == before_lng)
    if (same_position) same_position.setStyle({ fill: 1, fillOpacity: 0.4 })
  }

  onStepEnter = e => {
    const { data, entry, direction } = e;
    this.setState({ data });

    // 地図を移動
    let index = this.state.steps.map(el => el.value).indexOf(data)
    let obj = this.state.steps[index]
    if (index !== -1) {
      if (obj.highlightID) this.addHighlight(obj.highlightID)
      if (obj.centerPos) this.flyTo(obj.centerPos, obj.zoomLevel)
      if (obj.areaColoring) {
        this.refs.beforeProvinceData.setStyle({ fill: 1, fillOpacity: 0.4, fillColor: obj.team == '東' ? "darkgreen" : "mediumpurple" })
        this.refs.afterProvinceData.setStyle({ fill: 1, fillOpacity: 0.4, fillColor: obj.team == '東' ? "yellowgreen" : "plum" })
      }
    }
    // sekigaharaList[this.state.steps[index].highlightID - 1]

    if (data == 11) {
      this.beforeCircleRefs.forEach(el => {
        el.setStyle({ fillOpacity: 0.4 })
      })
      this.afterCircleRefs.forEach(el => {
        el.setStyle({ fillOpacity: 0 })
      })
    }
    if (data == 12) {
      this.beforeCircleRefs.forEach(el => {
        el.setStyle({ fillOpacity: 0 })
      })
      this.afterCircleRefs.forEach(el => {
        el.setStyle({ fillOpacity: 0.4 })
      })
    }

    // if (data == 50) {
    //   this.refs.sampleCircle
    //     .setLatLng([35, 140])
    //     .setStyle({
    //       fillColor: "black"
    //     })
    //     .update()
    // }

    // if (data == 50) {
    //   const { map } = this.state;
    //   this.beforeCircleRefs[16].setStyle({ fillOpacity: 0.25, stroke: false });
    //   console.log(this.beforeCircleRefs[16].getLatLng())
    //   this.beforeCircleRefs[16].setLatLng([38, 136]).redraw(); 
    //   this.beforeCircleRefs[16]._latlng = [38, 136]
    //   map.locate()
    //   map.update()
    //   map._renderer._update();
    // }
  };

  onStepExit = ({ direction, data }) => {
    if (direction === 'up' && data === this.state.steps[0]) {
      this.setState({ data: 0 });
    }

    if (data == 12) {
      this.beforeCircleRefs.forEach(el => {
        el.setStyle({ fillOpacity: 0.4 })
      })
      this.afterCircleRefs.forEach(el => {
        el.setStyle({ fillOpacity: 0 })
      })
    }

    let index = this.state.steps.map(el => el.value).indexOf(data)
    let obj = this.state.steps[index]
    if (index !== -1 && this.state.steps[index].highlightID) {
      if (obj.highlightID) this.removeHighlight(obj.highlightID)
      if (obj.areaColoring) {
        this.refs.beforeProvinceData.setStyle({ fill: 0 })
        this.refs.afterProvinceData.setStyle({ fill: 0, fillColor: obj.team == '東' ? "yellowgreen" : "plum" })
      }
    }
  };

  onStepProgress = ({ data, progress }) => {
    this.setState({ progress });

    // 移動
    let index = this.state.steps.map(el => el.value).indexOf(data)
    if (index !== -1 && this.state.steps[index].highlightID) {
      this.addHighlight(this.state.steps[index].highlightID, this.state.steps[index].zoomLevel)
      // if (progress == 1) this.addHighlight(this.state.steps[index].highlightID, false)
    }

    // 透過度を元に戻す
    if (data === 50) {
      this.beforeCircleRefs.forEach(el => {
        el.setStyle({
          fillOpacity: 0.4
        });
      })
    }
  };

  provinceStyle = {
    fill: 0,
    stroke: 0
  }

  render() {
    const { data, steps, progress, zoomLevel, initialCenterPos } = this.state;
    const { classes } = this.props;

    function selectColor(val) {
      switch (val) {
        case "east", "東":
          return "yellowgreen"
        case "西→東":
          return "mediumaquamarine"
        case "west", "西":
          return "plum"
        case "東→西":
          return "lightsalmon"
        case "neutral":
          return "silver"
        default:
          return "silver"
      }
    }

    function SetViewOnClick({ animateRef }) {
      const map = useMapEvent('click', (e) => {
        map.setView(e.latlng, map.getZoom(), {
          animate: true,
        })
      })
      return null
    }

    return (
      <div>
        <div className={classes.graphicContainer}>
          <div id="map" className={classes.graphic}>
            {/* <p>{data}</p> */}
            {/* {console.log(data, progress)}
            {data == 20 ? "hello" : "bye"} */}
            <MapContainer whenCreated={map => this.setState({ map })} center={initialCenterPos} zoom={zoomLevel} zoomControl={false} scrollWheelZoom={false} stroke="#ff0000">
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                // url="https://cyberjapandata.gsi.go.jp/xyz/blank/{z}/{x}/{y}.png"
                url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
              // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {/* <FullscreenControl position="bottomleft" /> */}
              <ZoomControl position="topleft" />
              {/* <LayerGroup id="lg1">
                {kml && <ReactLeafletKml kml={kml} />}
              </LayerGroup> */}
              {/* <SetViewOnClick showRef={showRef} /> */}
              {/* <CircleMarker ref="sampleCircle" center={[35, 132]} radius={100} /> */}
              <GeoJSON ref="beforeProvinceData" style={this.provinceStyle} attribution="&copy; credits due Shiba Emiko ESRIジャパン株式会社" data={BeforeProvinces.features} />
              <GeoJSON ref="afterProvinceData" style={this.provinceStyle} attribution="&copy; credits due Shiba Emiko ESRIジャパン株式会社" data={AfterProvinces.features} />
              {sekigaharaList.map((el, index) => {
                return (
                  <Circle
                    // eventHandlers={ventHandlers}
                    ref={(beforeCircleRef) => this.beforeCircleRefs[index] = beforeCircleRef} 
                    name={el.name}
                    key={"before"+index}
                    num={el.id}
                    team={el.team}
                    center={[el['before.lat'], el['before.lng']]}
                    after_kokudaka={el['after.kokudaka']}
                    after_latlng={[el['after.lat'], el['after.lng']]}
                    radius={Math.sqrt(el['before.kokudaka'] / Math.PI) * 80 || 0}
                    stroke={false}
                    fillOpacity={0.4}
                    fillColor={selectColor(el.team)}
                  >
                    <Tooltip className="customTooltip" permanent={false} direction="top" offset={[0, -20]}>
                      <div className="flex">
                        <span className="font-bold text-lg mr-2">{el.name}</span>
                        <div class="py-1">
                          <span
                            className="px-2 py-1 rounded font-bold text-white"
                            style={{ backgroundColor: selectColor(el.team)}}
                          >
                            {el.team == '東' ? "東軍" : "西軍"}
                          </span>
                        </div>
                      </div>
                      <strong>旧領：{el['before.province']}{el['before.base']} {el['before.kokudaka'] / 10000}万石</strong> →<br />新領：{el['after.province']}{el['after.base']} {el['after.kokudaka'] / 10000}万石
                    </Tooltip>
                  </Circle>
                )
              })}
              {sekigaharaList.map((el, index) => {
                return (
                  <Circle
                    ref={(afterCircleRef) => this.afterCircleRefs[index] = afterCircleRef} 
                    name={el.name}
                    key={"after"+index}
                    num={el.id}
                    team={el.team}
                    center={[el['after.lat'], el['after.lng']]}
                    before_kokudaka={el['before.kokudaka']}
                    before_latlng={[el['before.lat'], el['before.lng']]}
                    radius={Math.sqrt(el['after.kokudaka'] / Math.PI) * 80 || 0}
                    stroke={false}
                    fillOpacity={0}
                    fillColor={selectColor(el.team)}
                  >
                    <Tooltip className="customTooltip" permanent={false} direction="top" offset={[0, -20]}>
                      <div className="flex">
                        <span className="font-bold text-lg mr-2">{el.name}</span>
                        <div class="py-1">
                          <span
                            className="px-2 py-1 rounded font-bold text-white"
                            style={{ backgroundColor: selectColor(el.team)}}
                          >
                            {el.team == '東' ? "東軍" : "西軍"}
                          </span>
                        </div>
                      </div>
                      旧領：{el['before.province']}{el['before.base']} {el['before.kokudaka'] / 10000}万石 →<br /> <strong>新領：{el['after.province']}{el['after.base']} {el['after.kokudaka'] / 10000}万石</strong>
                    </Tooltip>
                  </Circle>
                )
              })}
              <Tooltip ref="sampleTooltip" className="CustomTooltip" direction="top" offset={[0, -20]}>hello
              </Tooltip>
              <SetViewOnClick />
            </MapContainer>
          </div>
          <div className={classes.scroller}>
            <p class="text-center text-white text-6xl">第2編</p>
            <Scrollama
              onStepEnter={this.onStepEnter}
              onStepExit={this.onStepExit}
              progress
              onStepProgress={this.onStepProgress}
              offset="400px"
            // debug
            >
              {steps.map(el => {
                const isVisible = el.value === data;
                const visibility = isVisible ? 'visible' : 'hidden';
                return (
                  <Step data={el.value} key={el.value}>
                    <div class="step-wrapper">
                      <div class="box" className={classes.step}>
                        {el.title && <p class="title">{el.title}</p>}
                        <p>{el.description}</p>
                      </div>
                    </div>
                  </Step>
                );
              })}
            </Scrollama>
          </div>
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(Map);


// https://stackoverflow.com/questions/64665827/react-leaflet-center-attribute-does-not-change-when-the-center-state-changes